import ResponsiveAppBar from "./Menu";


export default function Navbar({rm}){
    return (
        <>
           <ResponsiveAppBar rm={rm}/>
        </>
    );
}